export {
  default as largeShallowArea,
  ReactComponent as LargeShallowArea,
} from '@assets/icons/features-and-amenities/large-shallow-area.svg'    
